import { useState } from "react";
import { callAPIForQuery } from "../../../utilities/service";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const BranchView = () => {
    const navigate = useNavigate();
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [input, setInput] = useState({
        from_date: moment().format('YYYY-MM-DD'),
        to_date: moment().format('YYYY-MM-DD'),
    });

    const updateInputInfo = (key: string, value: string) => {
        setInput((prev) => ({
            ...prev,
            [key]: value
        }));
    };

    const fetchBranches = async () => {
        setLoading(true);
        setError(""); // Clear previous errors
        try {
            const response = await callAPIForQuery(
                { input: JSON.stringify({ from_date: input.from_date, to_date: input.to_date }), type: "get_branch" },
                "post"
            );
            setBranches(response[0] || []);
        } catch (err) {
            setError("Failed to load branches");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-lg-2">
                    <div className="form-option">
                        <label className="field-title">From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={input.from_date}
                            onChange={(e) => updateInputInfo("from_date", e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-2">
                    <div className="form-option">
                        <label className="field-title">To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={input.to_date}
                            onChange={(e) => updateInputInfo("to_date", e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-1">
                    <div className="form-option">
                        <label className="field-title hide">Search</label>
                        <input type="button" value="Search" className="form-control" onClick={fetchBranches} />
                    </div>
                </div>
            </div>

            {loading && <p>Loading branches...</p>}
            {error && <p className="text-danger">{error}</p>}

            <div className="appointment-grid">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Branch Code</th>
                            <th>Branch Name</th>
                            <th>Contact No</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th>Pincode</th>
                            <th>Tenant</th>
                            <th>Hospital</th>
                            <th>Active</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {branches.length > 0 ? (
                            branches.map((branch: any) => (
                                <tr key={branch.id}>
                                    <td>{branch.id}</td>
                                    <td>{branch.code}</td>
                                    <td>{branch.name}</td>
                                    <td>{branch.contact_no}</td>
                                    <td>{branch.email_id}</td>
                                    <td>{branch.address}</td>
                                    <td>{branch.pincode}</td>
                                    <td>{branch.tenant_name}</td>
                                    <td>{branch.hospital_name}</td>
                                    <td>{branch.isactive ? "Yes" : "No"}</td>
                                    <td><span className="action-link" onClick={() => {
                                        navigate(`/branch-create?id=${branch.id}`)
                                    }}>View</span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={10} className="text-center">No branches found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default BranchView;
